module.exports = __webpack_public_path__ + "static/bg_gallery_fallback-a69cf60cf489c1f5f3cf1ec1cd5d3665.png";